import { Component, OnInit, AfterViewInit, Input, ViewChild, OnChanges, Output, EventEmitter, OnDestroy, ElementRef, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { SortHelper } from 'shtools';
import * as lodash from 'lodash';

import { SolarBaseComponent } from '@solar/solar/solar-base';
import { Site, Supervision, SupervisionError, SupervisionStatusEnum, Panel, SupervisionErrorStatusEnum, IssueType, SupervConstants, Flight, ImageItemTag } from 'solar-bo';
import { FrCoordinate, FrLayer } from 'gmap';
import { SupervMapComponent } from '../superv-map/superv-map.component';


import { MessageError } from 'base-models';
import { AlertType, NotificationType } from 'base-models';
import { IssueListComponent } from '../issue-list/issue-list.component';
import { MapSupervisionHelper, MapIssueOverlay, MapSiteHelper } from '@solar/ol';
import { OlObjectTypeEnum } from 'solar-bo';;
import { IssueImageComponent } from '../issueimage/issueimage.component';
import { SupervStatusComponent } from '../superv-status/supervstatus.component';


import { OlMapBaseComponent } from 'gmap';
import * as ol from 'ol';
import { Vector as ol_source_Vector, ImageStatic } from 'ol/source';
import { MapOnMoveHelper } from 'gmap';

import * as ol_style from 'ol/style';

import { MapRasterHelper } from 'gmap';
import { MapSupervisionIssues } from '@solar/ol/map-supervision-issues';

import { DBFilterComponent } from '../../dashboard/db-filter/db-filter.component';
import { DBColumnsEnum, DB_filter } from 'solar-bo';

import { SupervisLoader } from './supervis-loader';

import { ControlEnum } from 'solar-bo';
import { SupervisionFilter } from './supervis-filter.model';
import { TimePerf } from 'shtools';
import { MessagebarComponent } from 'basecomponents';

import { mapcte } from 'gmap';
import { AppConfig } from '@solar/app.config';
import { IssueListValidatorComponent } from '../issue-list/issue-list-validator.component';
import { ImageItem } from 'solar-bo';;
import { IssueImage } from 'solar-bo';
import { Image as ImageLayer } from 'ol/layer';
import Static from 'ol/source/ImageStatic';
import Circle from 'ol/geom/Circle';
import { SupervOptionsComponent } from './superv-options/superv-options.component';
import { SupervStatusIconComponent } from '../superv-status/supervstatusicon.component';
import { MapPanelStyle } from '@solar/ol';
import { MapPanelSourceHelper } from '@solar/ol/map-panel-source-helper';
import { OlMapOptions } from 'gmap';
import { ImageThumbGalleryComponent } from '@solar/solar/img-gallery/imagethumbgallery.component';
import { SupervMainService } from './superv-main-service.service';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { timer } from 'rxjs';
import { IssueTypeHelper } from '@solar/solar/models';
import { FilterItem, FilterItemCollection, GenFilter, IFilterItemCollection } from '@solar/solar/dashboard/db-filter/filter';
import { DBG, DebugLevelEnum } from '@solar/shared/dbg.model';
import { takeWhile } from 'rxjs/operators';
import { isThisTypeNode } from 'typescript';
import { TooltipIssue } from '@solar/ol/tooltip-issue.model';
import { MapControlAction } from 'projects/gmap/src/lib/models/map-actions.model';
import { IMapControlAction } from 'dist/gmap/lib/models/map-actions.model';


//TODO: ocultar status change button dependiendo del usuario. Aunque se muestra no hace nada si no tiene los permisos 

/**
 * Se ha creado el servicio para comenzar a mover los datos compartidos al servicio SupervMainService
 */
@Component({
  selector: 'app-ex-supervis',
  templateUrl: './supervis.component.html',
  styleUrls: ['./supervis.component.scss']
  , providers: [SupervMainService]
})
export class SupervisComponent extends SolarBaseComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {


  static validationType: string = "VALIDATION";
  /**
   * we use this to hide components until required data exists or for problems between Angular and DOM third components
   */
  componentStatus: any = { data: "LOADING", map: false, panelissuesloaded: false };

  @Input() id_supervision: string;
  @Input() supervision: Supervision;
  @Input() site: Site;
  site_panels_type: any[] = [];
  site_panels: any[] = [];

  private _issues: SupervisionError[] = [];//all issues
  @Input() public get issues(): SupervisionError[] {
    return this._issues;
  }
  public set issues(value: SupervisionError[]) {
    this._issues = value;
  }

  private _issuesFiltered: SupervisionError[] = [];
  public get issuesFiltered(): SupervisionError[] {
    return this._issuesFiltered;
  }
  public set issuesFiltered(value: SupervisionError[]) {
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "issuesFiltered this.issues.length: " + this.issues.length + " issuesFiltered: " + this.issuesFiltered.length);
    this._issuesFiltered = value;
  }
  validatorIssuesData:{ issues: SupervisionError[] ,issuesFiltered: SupervisionError[]};
  /**
   * issue selected
   */
  issueSelected: SupervisionError;

  svFilter: SupervisionFilter = new SupervisionFilter();// {} as SupervisionFilter;

  @Output() issueSelectedEvent: EventEmitter<any> = new EventEmitter();

  @ViewChild('supervmapcomp') mapc: SupervMapComponent;
  @ViewChild('issuelistcomp') issuesComponent: IssueListComponent;
  @ViewChild('supervisionstatus') supervisionstatus: SupervStatusComponent;
  @ViewChild('messagebar') messagebar: MessagebarComponent;
  @ViewChild('imagethumbgallery') imageThumbGallery: ImageThumbGalleryComponent;
  /**
   * Tab component
   */
  @ViewChild('tabgroup') tabgroup: TabsetComponent;
  /**
   * options for issue component
   */
  issuesComponent_options: { movenext: boolean } = { movenext: false };
  /**
   * options for map
   */
  map_options: { map_panel_onclick_showThermal: boolean, issue_change_showImageProjected: boolean } = {
    map_panel_onclick_showThermal: true
    , issue_change_showImageProjected: true
  };

  mapcomponent_options: OlMapOptions;


  //options 
  /**
   * Show/hide dashboard based on supervision status
   */
  dashboardVisible: boolean = false;
  supervisionLoaded: boolean = false;
  mapVisible = true;
  errorsVisible = true;
  showEditIssue = false;
  supervisionEditVisible: boolean = false;
  supervisionMapsVisible: boolean = true;
  checkModel: any = { left: false, middle: true, right: false };
  readOnlyViewType: boolean = true;
  showReportButton = false;
  //map
  map: OlMapBaseComponent;
  issueOverlay: MapIssueOverlay;
  mapOnMoveHelper: MapOnMoveHelper;
  mapSupervisionIssues: MapSupervisionIssues;
  panelLayer: MapPanelSourceHelper = new MapPanelSourceHelper();
  mapPanelStyle: MapPanelStyle;
  mapIssueTooltip:TooltipIssue;
  mapHeight: string = "800px"
  private map_initial_zoom: number = 19;
  @ViewChild('mapTooltip') mapTooltip:ElementRef;

  /**
 * layer with most recent panel
 */
  private layerWithActualSelectedPanel_id: string = "layerWithActualSelectedPanel_id";
  /**
 * layer with most recent panel
 */
  private layerWithActualSelectedImage_id: string = "layerWithActualSelectedImage_id";
  /**
   * layer object with issues
   */
  layer_Issues: any;
  layer_IssuesZIndex: number = 10;
  /**
   * layer with panels
   */
  layer_SitePanels: any;
  layer_SitePanelsZIndex: number = 5;
  /**
   * site layer boundary
   */
  siteLayerLimits: any;
  /**
   * min zoom to show panels, when the number of panels is elevated we must increment this value
   */
  minZoomIssues: number = 18.7;
  minZoomPanels: number = 19.8;
  /**
 * Show hide issue toolbar
 */
  showIssueToolbar: boolean = false;
  toolbaserSelected: string = "tab_supervisiondata";
  showCaroussel: boolean = false;
  //toolBar:[{id:string}]=[];

  /**
   * route1: ActivatedRoute no funciona con herencia, al menos en la version 8
   */
  constructor(public route1: ActivatedRoute
    , private supvService: SupervMainService
    , private elementRef: ElementRef) {

    super();
    this.TAG = "SupervisComp";
    let mapActions:IMapControlAction[]=[];
    mapActions.push({titleText:'Show filter',icon:'fas fa-filter',disabled:false, callBack:this.filterOpenModal.bind(this)});
    mapActions.push({titleText:'Full screen',icon:'fas fa-expand-alt',disabled:false, callBack:this.mapFull.bind(this)});
    this.mapcomponent_options = new OlMapOptions({ zoomPosition: 'RIGHT' ,showCoords: true, actions:mapActions });

    this.svFilter.filterSelected = [];
    this.svFilter.filter_status = SupervisionErrorStatusEnum.none;
    this.mapSupervisionIssues = new MapSupervisionIssues();
    this.mapSupervisionIssues.validationMode = false;
    this.mapPanelStyle = new MapPanelStyle();
    this.loadUserConfig();
    this.globService.routeReuseStrategyEvent.subscribe(event => this.routeReuseStrategyEventHandler(event));

    //this.routeConfigEventsHandler();
  }

  mapFull(){
    const body = document.body;
    let map = document.getElementById(this.map.id);
    if (!map){
      return;
    }
    if (map.style.position!='fixed'){
      map.style.position = 'fixed';
      //this.viewport_.style.overflow = 'hidden';
      map.style.top = '0px';
      map.style.left = '0px';
      map.style.zIndex = '1030';
      map.style.width = '100%';
      map.style.height = '100%';
      map.style.backgroundColor="rgb(255,255,255)";
    }else{
      //this.viewport_ = document.createElement('div');
        map.style.position = 'relative';
        //this.viewport_.style.overflow = 'hidden';
        map.style.top = '0px';
        map.style.left = '0px';
        map.style.zIndex = 'auto';
        map.style.width = '100%';
        map.style.height = '100%';      
    }

    this.map.refreshSize();
  }


  ngOnInit() {
    let id = null;
    if (this.id_supervision != null) {
      id = this.id_supervision;
    } else if (this.id_supervision == null) {
      id = this.route1.snapshot.paramMap.get('id');
      this.id_supervision = id;
    }

    //this.getInitialData(id);

  }

  ngAfterViewInit() {
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "ngAfterViewInit");
    this.supervisionstatus.statusChange.subscribe(res => this.supervisionstatusStatusChangeHandler(res));
    this.showMap = true;
    this.showMapAsync();
    this.getInitialData(this.id_supervision);
  }

  ngOnChanges() {

  }

  ngOnDestroy() {
    if (this.refreshSupervisionDatainterval) {
      clearInterval(this.refreshSupervisionDatainterval);
    }
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "ngOnDestroy");
  }

  private mapConfigListeners() {
    this.map.onFeatureClick.subscribe(res => this.map_onFeatureClick(res));
    //this.map.onSingleClick.subscribe(res => this.map_onSingleClick(res));
    this.mapOnMoveHelper = new MapOnMoveHelper(this.mapc.map);

    this.issueOverlay = new MapIssueOverlay(this.mapc.map);
    this.issueOverlay.showText=false;
    this.mapOnMoveHelper.addListener(this.issueOverlay);
    this.issueOverlay.addLayer(this.layerWithActualSelectedPanel_id);
    //
    console.log("mapTooltip", this.mapTooltip);
    console.log("mapTooltip", document.getElementById('mapTooltip'));
    this.mapIssueTooltip=new TooltipIssue(this.map,this.mapTooltip);
  }


  private routeReuseStrategyEventHandler(event: any) {
    let thisURL = (this.route1 as any)._routerState.snapshot.url;
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "routeReuseStrategyEventHandler", event, thisURL);
    if (event.value != thisURL) {
      return;
    }
    if (event.type == "STORE") {
      this.reuseStrategy_Detach();
    } else if (event.type == "RESTORE") {
      this.reuseStrategy_Atach();
    }
  }
  /**
   * test for use with routestrategy
   */
  private routeConfigEventsHandler() {
    this.router.events.subscribe((routeEvent) => {

      //no sirve con ReuseStrategy, esta activo todo el tiempo
      if (routeEvent instanceof NavigationEnd) {
        DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "NavigationEnd--------------", routeEvent); //instanceof NavigationEnd
        //this.reuseStrategy_Atach();
      } else if (routeEvent instanceof NavigationStart && routeEvent.url == (this.route1 as any)._routerState.snapshot.url) {
        DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "NavigationStart------------------", routeEvent);
        //this.reuseStrategy_Detach();
      }
      DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "navigation router.events:", routeEvent);
      DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "navigation ActivatedRoute:", this.route1);
      //NavigationStart
      // NavigationEnd
      // NavigationCancel
      // NavigationError
      // RoutesRecognized
    });
  }

  reuseStrategy_Detach() {
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "reuseStrategy_Detach() called on supervision");
    if (this.refreshSupervisionDatainterval) {
      clearInterval(this.refreshSupervisionDatainterval);
    }
  }

  reuseStrategy_Atach() {
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "reuseStrategy_Atach() called on supervision");
    //IMPORTANT: reuseStrategy is called twice
    if (this.readOnlyViewType == false) {
      this.configureRefreshSupervisionData();
    }
  }



  showMap = false;
  private showMapAsync() {
    let cls = this;
    //emit 0 after  complete, since no second argument is supplied
    const source = timer(250);
    const subscribe = source.subscribe(val => {
      cls.showMap = true;
      if (cls.mapc) {
        cls.map = cls.mapc.map;
        //this.map.map_view.setMinZoom(17.5);
        cls.map.layerVisibilityChanged.subscribe(res => cls.layerVisibilityChanged(res));
        cls.mapConfigListeners();
      }
      else {
        cls.showerror("There is a problem loading map. Please load supervisión again.");
      }
    });

  }

  private layerVisibilityChanged(layer: any) {
    if (layer[mapcte.frlayerinfo_FieldName].id == this.site.id) {
      this.siteVisible = layer.getVisible();
    }
  }

  getInitialData(id_supervision: string) {
    this.loading = true;
    this.alertmessage = new MessageError(AlertType.Info, "Loading supervision data, please wait.");
    let cl = new SupervisLoader(this.solarService);
    cl.configStatusEvent.subscribe(res => this.configureDataTreeStatus(res));
    cl.configEndEvent.subscribe(res => this.configureDataTree(res));
    cl.configErrorByTypeEvent.subscribe(res => this.handleLoadError(res));
    cl.getSupervisionData(id_supervision);

  }

  configureDataTreeStatus(res) {
    this.alertmessage = new MessageError(res.type, res.message);
  }

  configureDataTree(res) {

    this.supervisionLoaded = true;
    this.alertmessage = null;
    let msg = new MessageError(AlertType.Success, "Supervision data ready, configuring map, please wait.");
    this.alertmessage = msg;

    timer(100)
      .subscribe(val => {
        this.configureDataTreeEnqueued(res);
      });
    /*     setTimeout(function () {
          this.configureDataTreeEnqueued(res);
          //cls.notifier.notify(NotificationType.Success, "Supervision data loaded");
        }.bind(this), 100); */

  }

  configureDataTreeEnqueued(res) {
    try {
      let startTime = new Date();
      let cls: SupervisComponent = this;
      cls.supervision = res.supervision;
      cls.site = cls.supervision.site;
      cls.site_panels_type = res.site_panels_type;
      cls.site_panels = res.site_panels;

      cls.readOnlyViewType = cls.uiShowIssueListType();

      cls.mapSupervisionIssues.validationMode = !cls.readOnlyViewType;
      if (cls.readOnlyViewType == true) {
        cls.showReportButton = false;

        let validatedIssues: SupervisionError[] = res.issues;
        let issueStatusFilter: SupervisionErrorStatusEnum;
        if (cls.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
          //quitamos los NDM, Box y Unk
          validatedIssues = validatedIssues.filter((elem: SupervisionError) => elem.info.status == SupervisionErrorStatusEnum.validated
            && elem.info.statusType != SupervisionErrorStatusEnum.noerror
            && (elem.info.issueRepeated == false || elem.info.issueRepeated == null));
        }
        else {
          //mostramos todos menos los noerror y repeated?
          validatedIssues = validatedIssues.filter((elem: SupervisionError) =>
            elem.info.statusType != SupervisionErrorStatusEnum.noerror
            && (elem.info.issueRepeated == false || elem.info.issueRepeated == null));
        }

        //sea cual sea el estado estos no los mostramos
        let typeToAvoid = [IssueType.CBOX, IssueType.NDM, IssueType.UNK];
        validatedIssues = validatedIssues.filter(elem => typeToAvoid.indexOf(elem.type) === -1);
        res.issues = validatedIssues;
      } else {
        if (cls.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
          cls.showReportButton = false;
        }
        else {
          cls.showReportButton = true;
        }

      }

      cls.issues = cls.SortIssueList(res.issues);
      cls.issuesFiltered = cls.issues;

      cls.configFilters();
      this.configMapData();
      /*       this.map_drawSite();
            this.map_drawSitePanels(this.supervision);
            this.map_drawPanelErrors(this.supervision,this.issuesFiltered); */
      cls.componentStatus.data = "LOADED";
      //esta mierda no funciona
      /*         timer(100,100)
              .pipe(takeWhile(val_notused=> this.map==null,true))
              .subscribe(val => {
                //this.configMapData();
              }); */
      TimePerf.timeElapsed(startTime, "Supervision configureDataTree");
      if (cls.readOnlyViewType == false) {
        cls.configureRefreshSupervisionData();
      }


      cls.alertmessage = null;
      //todo: mostrar en funcion del estado
      if (cls.supervision.info.status == SupervisionStatusEnum.VALIDATED || cls.supervision.info.status == SupervisionStatusEnum.TOVALIDATE) {

        cls.dashboardVisible = true;
      }
      else {
        //remove tab
        let tab = this.tabgroup.tabs.find(t => t.id == 'tab_supervisiondashboard');
        this.tabgroup.removeTab(tab);

        let auth: boolean;
        auth = this.globService.checkAuthorizationById(ControlEnum.SUPERVISION_VALIDATOR);
        if (!auth){
          let tabIssues = this.tabgroup.tabs.find(t => t.id == 'tab_issues');
          this.tabgroup.removeTab(tabIssues);
        }
        
        
      }

      cls.loading = false;
    }
    catch (err) {
      DBG.log(DebugLevelEnum.ERROR, this.TAG, err);
      this.showerror("Error loading supervision. Please try again.", err);
      this.loading = false;
    }
  }

  configMapData() {
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "configMapData", this.map);

    this.map_drawSite();
    this.map_drawSitePanels(this.supervision);
    this.map_drawPanelErrors(this.supervision, this.issues);
    this.mapSetDefaultView();


    let canViewProjectedImages = this.globService.checkAuthorizationById(ControlEnum.SEC_SUPERV_VALIDATOR);
    if (canViewProjectedImages) {
      MapSupervisionHelper.loadSupervisionProjectedImagesMap(this.map, false);
    }
  }


  mapSetDefaultView() {
    if (this.issuesFiltered.length > 0) {
      this.map.setZoomToExtent(this.layer_Issues);
    } else {
      DBG.log(DebugLevelEnum.INFO, this.TAG, "configMapData");
      this.map.setZoomToExtent(this.siteLayerLimits);
    }
  }

  /**
   * Refresh only issues
   */
  refreshIssues() {
    this.getInitialData(this.id_supervision);
  }

  refreshSupervisionDatainterval: any;
  configureRefreshSupervisionData() {

    if (this.refreshSupervisionDatainterval) {
      clearInterval(this.refreshSupervisionDatainterval);
    }
    this.refreshSupervisionDatainterval = setInterval(() => {
      this.refreshSupervisionData();
    }, 7000);
  }

  SortIssueList(issues: SupervisionError[]) {
    let validationType = this.uiShowIssueListType();
    let sorted: any;
    if (!validationType) {
      sorted = SortHelper.sortMultiple(issues, ['info.date', 'info.panel.locator.L1', 'info.panel.locator.L2', 'info.panel.locator.L3', 'info.panel.locator.L4']);
    }
    else {
      sorted = SortHelper.sortMultiple(issues, ['info.panel.locator.L1', 'info.panel.locator.L2', 'info.panel.locator.L3', 'info.panel.locator.L4']);
    }
    return sorted;
  }

  refreshSupervisionDataIsRunning: boolean = false;
  refreshSupervisionData() {
    const element = this.elementRef.nativeElement;

    if (element.offsetParent === null) {
      // element is not visible
      return;
    }
    if (this.refreshSupervisionDataIsRunning) {
      return;
    }
    this.solarService.supervisionGetById(this.supervision.id)
      .subscribe(data => {
        try {
          DBG.log(DebugLevelEnum.TIMERS, this.TAG, "refreshSupervisionData");
          this.refreshSupervisionDataIsRunning = false;
          let supUpd: Supervision = <Supervision>data;
          this.supervision.info.status = supUpd.info.status;
          this.supervision.info.updating_date = supUpd.info.updating_date;
          this.supervision.info.errorsDetected = supUpd.info.errorsDetected;
          this.supervision.info.reports=supUpd.info.reports;
          if (this.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
            this.showReportButton = false;
          }
          else {
            this.showReportButton = true;
          }
        }
        catch (err) {
          this.refreshSupervisionDataIsRunning = false;
          DBG.log(DebugLevelEnum.VERBOSE, this.TAG, err);
        }

      });
  }


  map_drawSite(force?: boolean) {
    let site = this.site;
    try {
      if (!site) {
        return;
      }

      let frlayerinfo = new FrLayer(site.name, site.id);
      frlayerinfo.icon = "/assets/img/defaultmarker.png";
      frlayerinfo.tooltip = "Icon indicating the center of the site.";
      let layer = this.map.layerGetByFrid(frlayerinfo.id);
      if (layer) {
        if (force == true) {
          this.map.layerRemove(frlayerinfo.id);
        } else {
          return;
          //boundary is included too
        }

      }
      layer = this.map.layerCreateVectorLayer(frlayerinfo);

      if (site.info.location != null) {
        let mapSitesHelper = new MapSiteHelper();
        mapSitesHelper.markerCreate(layer, site.info.location[0], site.info.location[1], site.id, site.name);
      }

      let zoom: number = this.map.getZoom();
      this.map.layerAdd(layer);
      this.map.setCenter(this.site.info.location[0], this.site.info.location[1]);
      let newZoom: number = this.map_initial_zoom - zoom;
      if (newZoom > 0) {
        let view = this.map.map.getView();
        view.animate({ zoom: this.map_initial_zoom });
      }
      this.map.zoomUpdateManually();

      if (this.site.geom) {
        this.siteLayerLimits = MapSiteHelper.loadSiteGeometry("Site boundary", this.site.geom, "geom_" + this.site.id);

        this.map.layerAdd(this.siteLayerLimits);
        this.map.setZoomToExtent(this.siteLayerLimits);

        this.map.map_view.setMinZoom(this.map.getZoom());
      }

    } catch (ex) {
      DBG.log(DebugLevelEnum.VERBOSE, this.TAG, ex);
      this.alertmessage = new MessageError(AlertType.Info, "Error loading map" + ex);
    }

  }
  /**
   * handles changes in staus
   * @param status 
   */
  supervisionstatusStatusChangeHandler(status: SupervisionStatusEnum) {
    //todo: Necesitamos recargar el componente con los nuevos issues, hasta que lo tengamos lo que hacemos es recargar la pagina

    //this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/supervision-master/" + this.supervision.id);
    this.showNotificationInfo("Please wait while the supervision is reloaded with extra data.");
    this.reloadComponent();
    this.supervision.info.status = status;//ni llegaria
  }

  reloadComponent() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([AppConfig.ROUTE_SOLAR + "/supervision-master/" + this.supervision.id]);
  }

  issuesListAddNewIssue(issue: SupervisionError) {
    //console.log("issuesListAddNewIssue BEFORE ADD this.issues.length: " + this.issues.length + " issuesFiltered: " + this.issuesFiltered.length);
    this.issues.push(issue);
    this.SortIssueList(this.issues);
    //console.log("issuesListAddNewIssue AFTER ADD this.issues.length: " + this.issues.length + " issuesFiltered: " + this.issuesFiltered.length);
    //filter issuesFiltered
    this.filterSelectedEventHandler(this.svFilter.filterSelected);
    //console.log("issuesListAddNewIssue AFTER FILTER this.issues.length: " + this.issues.length + " issuesFiltered: " + this.issuesFiltered.length);
    this.supervision.info.errorsDetected=this._issues.length;
    //todo:server must update supervision issues
  }

  /**
   * 
   * @param svFilter 
   */
  validator_filterChangedEventHandler(svFilter: SupervisionFilter) {
    this.filterSelectedEventHandler(svFilter.filterSelected);
  }
  /**
   * handles validator generic events
   * @param event 
   */
  validator_componentEventHandler(event: any) {
    if (event.eventName === SupervConstants.ISSUE_ADDED) {
      let issue: SupervisionError = event.value;

      this.issuesListAddNewIssue(issue);

      this.map_drawPanelWithError(issue);
      this.layer_Issues.changed();
    }
    else if (event.eventName === SupervConstants.ISSUE_PANEL_MODIFIED) {
      let issue: SupervisionError = event.value;
      this.issueDrawChangePanel(issue);
      this.layer_Issues.changed();
    }
    else if (event.eventName === SupervConstants.ISSUE_PANEL_REMOVE) {
      let issue: SupervisionError = event.value;
      this.issuePanelRemove(issue, this.layer_Issues);
      this.layer_Issues.changed();
    }
    else if (event.eventName === SupervConstants.ISSUE_EDIT_IMAGE_CHANGE) {
      let item: ImageItemTag = event.value;
      this.map_drawFlightImageProyected(item.flight, item.image, true);
      this.layer_Issues.changed();
    }
    else if (event.eventName === SupervConstants.ISSUE_ADD_FROM_IMAGE) {
      let item: ImageItemTag = event.value;
      //this.showAddIssueFromImage(event.value);
    }
    else if (event.eventName === "ISSUE_SAVED") {
      let item: ImageItemTag = event.value;
      this.layer_Issues.changed();
    }
  }



  /**
   * event initated by child component
   * @param event 
   */
  validator_issueChangePanelInitiatorEventHandler(event: { issue: SupervisionError, status: string, issueOrig: SupervisionError }) {

    let issue = event.issue;
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"issue_issueChangePanelInitiatorEventHandler", issue);
    this.issueSelected = issue;
    if (event.status == "START") {
      this.map_drawPanelSelected(this.issueSelected);

      if (this.map.getZoom() < 22) {
        this.map.setZoom(22);
      }

      this.showSitePanels("SHOW");
      this.map_onFeatureClick_ChangePanel = true;
    }
    else if (event.status == "CANCEL") {
      //CANCEL IS WHEN USER IS IN PROCESS FOR SELECT A NEW PANEL AND CANCEL
      this.map_onFeatureClick_ChangePanel = false;
      if (this.layer_SitePanels) {
        this.map.layerHide(this.layer_SitePanels);
      }
      return;
    }
    else if (event.status == "CHANGED") {
      this.map_onFeatureClick_ChangePanel = false;
      this.map.layerHide(this.layer_SitePanels);
      this.issueDrawChangePanel(this.issueSelected);
      this.map_drawPanelSelected(this.issueSelected);
      return;
    }
    else if (event.status == "RESTORE") {
      //RESTORE IS WHEN USER CHOOSED A NEW PANEL AND NOW WANT TO REVERT
      this.map_onFeatureClick_ChangePanel = false;
      this.map.layerHide(this.layer_SitePanels);
      //remove actual feature
      this.issuePanelRemove(this.issueSelected, this.layer_Issues);
      //redibuja 
      let panel_pattern = Site.getPanelPattern(this.site, "maps");
      MapSupervisionHelper.issuePolygonDraw(event.issueOrig, this.layer_Issues, panel_pattern, true);
      this.issueSelected = event.issueOrig;
      this.map_drawPanelSelected(this.issueSelected);
      return;
    }

  }

  /**
   * Event when an issue is selected.
   * @param issueSelected 
   */
  validator_issueSelectedEventHandler(issueSelected: SupervisionError) {
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,"issues_rowClickEvent", row);
    this.issueSelected = issueSelected;
    this.map_drawPanelSelected(this.issueSelected);
    //no se puede pintar el area de la imagen del issue porque no tenemos esos datos, hay que descargarlos previamente.
    //this.drawIssueFlightImageProyected(this.issueSelected);
    //sincronize gallery
    this.imageThumbGallerySelectImage(issueSelected);
    if (this.map_options.issue_change_showImageProjected) {
      if (issueSelected) {
        this.map_drawFlightImageProyected(issueSelected.flight, issueSelected.image, false);

      } else {
        //clear image
        this.map_drawFlightImageProyected(null, null, false);
      }

    }

  }
  /**
   * Select issue
   * @param issue 
   */
  selectIssue(issue: SupervisionError) {
    this.issueSelected = issue;
    this.issueSelectedEvent.emit(issue);
    this.issuesComponent.selectRowById(issue.id);
    this.map_drawPanelSelected(this.issueSelected, false);
    this.imageThumbGallerySelectImage(issue);
    if (this.map_options.issue_change_showImageProjected) {
      this.map_drawFlightImageProyected(this.issueSelected.flight, this.issueSelected.image, true);
    }
  }


  issueDrawChangePanel(issue: SupervisionError) {
    //remove actual feature
    this.issuePanelRemove(issue, this.layer_Issues);
    let panel_pattern = Site.getPanelPattern(this.site, "maps");
    MapSupervisionHelper.issuePolygonDraw(issue, this.layer_Issues, panel_pattern, true);
    return;
  }

  issuePanelRemove(issue: SupervisionError, layer: any) {
    try {
      let clayer = this.map.layerGetByFrid(layer);
      if (!clayer) {
        return;
      }
      let vectorSource: ol_source_Vector = clayer.getSource();
      let feature = vectorSource.getFeatureById(issue.id);
      if (feature) {

        feature.setStyle(null);
        vectorSource.removeFeature(feature);
        feature.dispose();
        DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "Feature removed");
      }
      else {
        DBG.log(DebugLevelEnum.INFO, this.TAG, "Feature removed not exist");
      }


    }
    catch (err) {
      DBG.log(DebugLevelEnum.VERBOSE, this.TAG, err);
    }
  }

  /**
   * Draw the panel for selected issue
   * @param issue 
   */
  private map_drawPanelSelected(issue: SupervisionError, moveto: boolean = true) {
    try {

      let parentLayer = this.map.layerGetByFrid(this.layerWithActualSelectedPanel_id);
      if (!parentLayer) {
        //creamos la capa que encapsula el panel seleccionado
        let layerinfo: FrLayer = new FrLayer("Issue Selected", this.layerWithActualSelectedPanel_id);
        parentLayer = this.map.layerCreateVectorLayer(layerinfo);
        parentLayer.setZIndex(this.layer_IssuesZIndex + 1);
        this.map.layerAdd(parentLayer);
        parentLayer.setStyle(this.mapIssueSelectedPanelStyle.bind(this));
      }

      let vectorSource = parentLayer.getSource();
      vectorSource.clear();
      if (!issue) {
        return;
      }
      let panel_pattern = Site.getPanelPattern(this.site, "maps");
      MapSupervisionHelper.issuePolygonDrawNoStyle(issue, parentLayer, panel_pattern);
      if (moveto) {
        this.movetoIssueLocation(issue);
      }

    }
    catch (err) {
      this.notifyerror(err, "Error ocurred trying to show the panel for selected issue");
    }
  }
  /**
   * Move to issue location
   * @param issue 
   */
  movetoIssueLocation(issue) {
    if (!issue) {
      return;
    }
    let loc = issue.info.panel.geom.coordinates[0][0];//set first point that is in 
    let newZoom = this.map.getZoom();

    //this.map.setLocation(new FrCoordinate(loc[0], loc[1], newZoom));
    let isin = this.map.viewContainCoords(loc);
    if (!isin || (newZoom < this.map_initial_zoom)) {
      if (newZoom < this.map_initial_zoom) {
        //comprobar de nuevo
        newZoom = 20;
      }

      this.map.setLocation(new FrCoordinate(loc[0], loc[1], newZoom));
    }

  }



  mapIssueSelectedPanelStyle(feature, resolution) {
    return this.mapSupervisionIssues.mapIssueSelectedPanelStyle(feature, resolution, this.issueSelected);
  }
  private map_drawIssueFlightImageProyected(issue: SupervisionError) {
    try {
      let parentLayer = this.map.layerGetByFrid(this.layerWithActualSelectedPanel_id);//esta capa siempre existe
      let vectorSource = parentLayer.getSource();
      //vectorSource.clear();
      MapSupervisionHelper.imagePolygonDrawNoStyle(issue.image, parentLayer);

      let circleFeature = this.map_drawCircle(issue.image.geom_shot.coordinates);
      if (circleFeature) {
        parentLayer.getSource().addFeature(circleFeature);
      }
    }
    catch (err) {
      this.notifyerror(err, "Error ocurred trying to show the proyected flight image");
    }
  }

  /**
   * Draw the image for selected issue
   * @param flight 
   * @param image 
   * @param moveto if true move to selected zone
   */
  private map_drawFlightImageProyected(flight: Flight, image: IssueImage, moveto: boolean = true) {
    try {
      let parentLayer = this.map.layerGetByFrid(this.layerWithActualSelectedImage_id);
      if (!parentLayer) {
        let layerinfo: FrLayer = new FrLayer("Issue selected flight image", this.layerWithActualSelectedImage_id);
        layerinfo.tooltip = "Image from which the error was obtained."
        parentLayer = this.map.layerCreateVectorLayer(layerinfo);
        parentLayer.setZIndex(this.layer_IssuesZIndex + 1);
        this.map.layerAdd(parentLayer);
        //parentLayer.setStyle(this.mapIssueSelectedPanelStyle.bind(this));
      }

      let vectorSource = parentLayer.getSource();
      vectorSource.clear();
      if (!flight || !image) {
        return;
      }

      let newZoom = this.map.getZoom();

      if (image.geom_polygon != null) {
        MapSupervisionHelper.imagePolygonDrawNoStyle(image, parentLayer);
        let circleFeature = this.map_drawCircle(image.geom_shot.coordinates);
        if (circleFeature) {
          parentLayer.getSource().addFeature(circleFeature);
        }
      }
      else {
        this.solarService.FlightImagesGetById(image.id).subscribe(
          res => {
            image.geom_polygon = res.geom_polygon;
            image.geom_shot = res.geom_shot;
            this.map_drawFlightImageProyected(flight, image, moveto);
          }
          , err => console.error(err)
        )
      }

      if (moveto) {
        if (image.geom_polygon && image.geom_polygon.coordinates && image.geom_polygon.coordinates.length > 0) {
          let loc = image.geom_polygon.coordinates[0][0];//set first point that is in 
          this.map.setLocation(new FrCoordinate(loc[0], loc[1], newZoom));
        }
      }


      //this.drawimagefile(image);
    }
    catch (err) {
      this.notifyerror(err, "Error ocurred trying to show the proyected flight image");
    }
  }

  map_drawCircle(coordinates: any[]) {
    if (!coordinates || coordinates.length !== 2) {
      return;
    }
    let circle = new Circle(coordinates, 0.000001);
    let feature = new ol.Feature(circle);
    feature.setStyle(
      new ol_style.Style({
        stroke: new ol_style.Stroke({
          color: '#e4ff04',
          width: 2
        })
      })
    );
    return feature;

    /*         let view = this.mapc.map.map.getView();
            let projection = view.getProjection();
            let resolutionAtEquator = view.getResolution();
            let center = view.getCenter();
            let pointResolution = projection.getPointResolution(resolutionAtEquator, center);
            let resolutionFactor = resolutionAtEquator/pointResolution;
            let radius = (0.1 / ol.proj.METERS_PER_UNIT.m) * resolutionFactor; */
  }

  map_drawimagefile(image: IssueImage) {
    //let bounds=new Bounds(27.418100, 35.771100, 28.388000, 36.558500);
    //let size=new ol.Size(640, 512);
    try {


      let loc = image.geom_polygon.coordinates[0][0];//set first point that is in 
      //let extent: any = [loc[0], loc[1], loc[2], loc[3]];
      let extent: any = [0, 0, 640, 512];
      let url = "https://prepro.geoaitech.com/images-supervision/e4b5de3c-a978-11ea-9b72-509a4c837ab7/supervisions/885d4158-bd40-11ea-9039-509a4c837ab7/output/thermal/images_rgb/dca0f998-bd41-11ea-9039-509a4c837ab7/DJI_0002.jpg";
      /*     let graphic = new ImageStatic1(
            'Image',
            url,
            bounds,
            size,
            { numZoomLevels: 3 }
          ); */

      let graphic = new ImageLayer({
        source: new Static({
          url: url,
          imageExtent: extent,
        }),
      });

      //map.addControl(new OpenLayers.Control.LayerSwitcher());
      this.map.layerAdd(graphic);
      //map.zoomToExtent(new OpenLayers.Bounds(27.418100, 35.771100, 28.388000, 36.558500));
    }
    catch (err) {
      DBG.log(DebugLevelEnum.ERROR, this.TAG, err);
    }
  }


  /**
   * 
   * @param features 
   */
  map_onSingleClick(event: any) {
    let pixel = event.pixel;
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, pixel);
    //this.displayFeatureInfo(pixel); 
    // Create a new popup instance each time the map is clicked, set the
    // ol.Overlay `insertFirst` option to false so that each new popup is
    // appended to the DOM and hence appears above any existing popups
    /*     var popup = new Popup({insertFirst: false});
        this.map.addOverlay(popup);
        var prettyCoord = ol.coordinate.toStringHDMS(ol.proj.transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326'), 2);
        popup.show(evt.coordinate, '<div><h2>Coordinates</h2><p>' + prettyCoord + '</p></div>'); */
  }

  //map_onFeatureClick_ShowImage: boolean = true;
  map_onFeatureClick_ChangePanel: boolean = false;
  map_onNewIssue_SelectPanel: boolean = false;
  /**
   * controls when click on map
   * @param features 
   */
  map_onFeatureClick(features: any[]) {

    if (!features) {
      return;
    }
    //let layers=this.map.map.getLayers();
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, features);
    for (let featInfo of features) {
      let feat = featInfo.feature;
      let layerinfo: FrLayer = feat.frlayerinfo;
      if (layerinfo) {
        if (layerinfo.ref == OlObjectTypeEnum.issue && !this.map_onFeatureClick_ChangePanel) {
          let issue = this.issuesFiltered.find(issue => issue.id == layerinfo.id);
          if (issue) {
            if (!this.issueSelected) {
              this.issueSelected = issue;
              this.issueSelectedEvent.emit(layerinfo.refObject);
              this.issuesComponent.selectRowById(issue.id);
              this.map_drawPanelSelected(this.issueSelected, false);
            }
            else if (issue.id != this.issueSelected.id) {
              this.issueSelected = issue;
              this.issueSelectedEvent.emit(layerinfo.refObject);
              this.issuesComponent.selectRowById(issue.id);
              this.map_drawPanelSelected(this.issueSelected, false);

            }
            this.imageThumbGallerySelectImage(issue);

            if (this.map_options.map_panel_onclick_showThermal) {
              IssueImageComponent.openModal(this.dialog, issue, this.supervision);
            }

            return;
          }
        } else if (layerinfo.ref == OlObjectTypeEnum.panel) {
          if (this.map_onFeatureClick_ChangePanel) {
            this.issueSelectedEvent.emit(layerinfo.refObject);
            this.issuesComponent.changePanel(layerinfo.refObject);
            //HIDE PANELS TO AVOID ERRRORS
            if (this.layer_SitePanels) {
              this.map.layerHide(this.layer_SitePanels);
              return;
            }
            this.map_onFeatureClick_ChangePanel = false;
          }
          else {
            //show dialogs options
            DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "Panel Selected", layerinfo.refObject);
          }
        }
      }
    }
  }

  siteVisible: boolean = true;
  siteshowhide() {
    this.siteVisible = !this.siteVisible;
    this.mapc.map.layerShowHide(this.site.id);
  }

  flightsVisible: boolean = false;
  showFlight(): boolean {
    this.mapVisible = !this.mapVisible;
    if (this.flightsVisible) {
      //hide flights
      this.flightsVisible = false;
    }
    else {
      this.flightsVisible = true;
      //cargar capa vuelo
    }
    return this.flightsVisible;
  }

  supervisionChangeStatus(icostatus: SupervStatusIconComponent) {
    if (!this.supervision) {
      return false;
    }
    icostatus.openStatusChange();
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
        <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css" integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
        </head>
        <style>

        </style>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  map_drawPanelErrors(superv: Supervision, reslist: SupervisionError[]) {
    try {
      //creamos la capa que encapsula los errores
      let layerinfo: FrLayer = new FrLayer('Issues Detected', superv.id, this.minZoomIssues);
      let layer = this.map.layerGetByFrid(layerinfo.id);
      if (layer) {
        this.map.layerRemove(layerinfo.id);
      }
      let parentLayer = this.map.layerCreateVectorLayer(layerinfo);
      parentLayer.setZIndex(this.layer_IssuesZIndex);
      parentLayer.setStyle(this.mapSupervisionIssues.panelsFilterStyle.bind(this.mapSupervisionIssues));
      this.layer_Issues = parentLayer;
      this.map.layerAdd(parentLayer);

      let panel_pattern = Site.getPanelPattern(this.site, "maps");
      for (let x = 0; x < reslist.length; x++) {
        let obj: SupervisionError = reslist[x];
        obj.supervision = superv;

        MapSupervisionHelper.issuePolygonDraw(obj, parentLayer, panel_pattern, true);
      }
      this.issueOverlay.layersId.push(superv.id);
    }
    catch (err) {
      this.notifyerror(err);
    }
  }

  /**
   * method to add a single panel when user add an issue manually
   * @param obj 
   * @param panel_pattern 
   */
  map_drawPanelWithError(obj: SupervisionError, panel_pattern?: string) {
    if (!panel_pattern) {
      panel_pattern = Site.getPanelPattern(this.site, "maps");
    }
    MapSupervisionHelper.issuePolygonDraw(obj, this.layer_Issues, panel_pattern, true);
  }
  /**
   * Check wich type of component to show based on supervision status and user profile
   * true means that is for end user
   */
  uiShowIssueListType(): boolean {
    if (!this.supervision || !this.supervision.info) {
      return true;
    }
    if (this.supervision.info.status == SupervisionStatusEnum.LOCKED
      || this.supervision.info.status == SupervisionStatusEnum.VALIDATED) {
      return true;
    }
    else {
      let edit = this.globService.checkAuthorizationById(ControlEnum.MAP_FLIGHT_IMAGES_LAYER);//TODO: ver o no ver issue list type con el permiso flight? Alguna prueba? 
      if (edit) {
        return false;
      }
      else {
        return true;
      }
    }
    return true;
  }

  /**
   * Return the list of panels of the site for supervision
   */
  showSitePanels(show: string = "TOGGLE"): void {
    let actualZoom = this.map.getZoom();
    if (show == "TOGGLE") {
      //alternate
      let isVisible: boolean = this.map.layerShowHide(this.layer_SitePanels);
      if (isVisible) {
        if (actualZoom <= this.minZoomPanels) {
          this.map.setZoom(this.minZoomPanels + 0.1);
        }
      }
      return;
    } else if (show == "SHOW") {
      //show
      this.map.layerShow(this.layer_SitePanels);

      if (actualZoom <= this.minZoomPanels) {
        this.map.setZoom(this.minZoomPanels + 0.1);
      }

      return;
    }

  }

  /**
   * draw all site panels
   * @param superv 
   * @param forceRefresh 
   */
  map_drawSitePanels(superv: Supervision, forceRefresh: boolean = false) {

    let layer = this.map.layerGetByFrid(MapPanelSourceHelper.LAYER_SITE_PANELS);
    if (layer) {
      if (forceRefresh == true) {
        this.map.layerRemove(MapPanelSourceHelper.LAYER_SITE_PANELS);
      }
      else {
        return;
      }

    }
    this.panelLayer.loadingEvent.subscribe(res => this.map_panelLoadingHandler(res));


    //create layer
    let parentLayer = this.panelLayer.loadSitePanelsMap(false, this.minZoomPanels, this.site.info.panel_locator_pattern.maps);
    //add pattern
    this.mapPanelStyle.panel_pattern = this.site.info.panel_locator_pattern.maps;
    //configuyre style
    parentLayer.setStyle(this.mapPanelStyle.panelsFilterStyle.bind(this.mapPanelStyle));
    parentLayer.setZIndex(this.layer_SitePanelsZIndex);
    this.layer_SitePanels = parentLayer;

    this.map.layerAdd(parentLayer);
    let frLayer: FrLayer = parentLayer[mapcte.frlayerinfo_FieldName];
    this.issueOverlay.layersId.push(frLayer.id);

  }

  map_panelLoadingHandler(res) {
    if (res == "LOADING") {
      this.mapc.loadingList = true;
      this.mapc.map.showmessage("Loading panels, please wait");
    } else if (res == "LOADING_END") {
      this.mapc.loadingList = false;
      this.mapc.alertmessage = null;

    } else if (res == "LOADING_END_ERROR") {
      this.mapc.loadingList = false;
      this.mapc.alertmessage = null;
      this.showNotificationError("An error ocurred loading panels.");
    }
  }

  map_drawSitePanels_old(superv: Supervision, reslist: any[]) {

    const layerId = superv.site.id + "_PANELS";
    let layerinfo: FrLayer = new FrLayer('Site panels', layerId, this.minZoomPanels);

    let parentLayer = this.map.layerCreateVectorLayer(layerinfo);
    parentLayer.setZIndex(this.layer_SitePanelsZIndex);
    this.layer_SitePanels = parentLayer;

    this.map.layerAdd(parentLayer);
    //parentLayer.setStyle(this.mapSupervisionIssues.panelsFilterStyle.bind(this.mapSupervisionIssues));
    let panel_pattern = Site.getPanelPattern(this.site, "maps");
    for (let x = 0; x < reslist.length; x++) {
      const obj: Panel = reslist[x];
      MapSupervisionHelper.panelPolygonDraw(obj, parentLayer, panel_pattern);
    }
    this.issueOverlay.layersId.push(layerId);
    this.loading = false;
  }

  showSupervisionDashboard = false;
  tab_showflights: boolean = false;
  onSelectTab($event) {
    this.toolbaserSelected = $event.id;
    switch ($event.id) {
      case "tab_supervisiondata":
        this.showIssueToolbar = false;
        break;
      case "tab_supervisiondashboard":
        this.showSupervisionDashboard = true;
        this.showIssueToolbar = false;
        break;
      case "tab_issues":
        let readOnlyViewType = this.uiShowIssueListType();
        this.showIssueToolbar = true;// && !readOnlyViewType;
        if (this.componentStatus.panelissuesloaded == false) {
          this.componentStatus.panelissuesloaded = true;
          this.map.refreshSize();
          if (this.issuesFiltered.length == 0) {
            timer(100)
              .subscribe(val => {
                this.map.setZoomToExtent(this.siteLayerLimits);
              });
          }
        }


        break;
      case "tab_flights":
        this.tab_showflights = true;
        this.showIssueToolbar = false;

        break;
      case "tab_reports":
        this.showIssueToolbar = false;
        break;
    }
  }

  uiShowCarousselBtn() {
    let readOnlyViewType = this.uiShowIssueListType();
    if (!this.showIssueToolbar) {
      return false;
    }

    if (readOnlyViewType) {
      return false;
    }
    return true;
  }

  imagethumbgallery_show_click() {
    if (this.showCaroussel) {
      this.showCaroussel = false;
      this.refreshMapContainerSize(true);
      return;
    }
    //config caroussel
    this.showCaroussel = true;
    this.refreshMapContainerSize(false);
  }

  imagethumbgallery_thumbClick($event) {
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,$event);
    if (!$event) {
      return;
    }
    let item = $event.item;
    //show image layout
    this.map_drawFlightImageProyected(item.tag.flight, item.tag.image, true);

  }

  imagethumbgallery_thumbOnRightClick($event) {
    //DBG.log(DebugLevelEnum.VERBOSE,this.TAG,$event);
    let galleryDTO: { gallery: any, imgDTO: ImageItem } = <any>$event;
    let imgData: ImageItem = galleryDTO.imgDTO;
    let objT: unknown = this.issuesComponent;
    let issuevalidator: IssueListValidatorComponent = <IssueListValidatorComponent>objT;
    let dto: { flight: Flight, image: IssueImage, gallery: any } = { flight: imgData.tag.flight, image: imgData.tag.image, gallery: galleryDTO.gallery };
    issuevalidator.addNewIssueFromImage(dto);

  }

  imagethumbgallery_onClose($event) {
    this.showCaroussel = false;
    this.refreshMapContainerSize(true);
    try {
      this.map.layerRemove(this.layerWithActualSelectedImage_id);
    }
    catch (err) {
      DBG.log(DebugLevelEnum.ERROR, this.TAG, err);
    }
  }

  private refreshMapContainerSize(expanded: boolean = true) {
    let cls = this;
    if (expanded) {
      cls.mapHeight = "800px";
      cls.mapc.mapHeight = "800px";
    }
    else {
      cls.mapHeight = "650px";
      cls.mapc.mapHeight = "650px";
    }


    setTimeout(function () {
      cls.map.refreshSize();

    }.bind(this), 100);
  }
  /**
   * Draw selected image projection on map
   */
  imageThumbGallerySelectImage(issue: SupervisionError) {

    if (!this.imageThumbGallery || !issue) {
      return;
    }

    let item = this.imageThumbGallery.selectImageByIssue(issue);
    if (item) {
      this.map_drawFlightImageProyected(item.tag.flight, item.tag.image, false);
    }
  }

  public dbFilter: GenFilter = new GenFilter();
  private configFilters() {

    let filterSites = new FilterItemCollection(DBColumnsEnum.site_id);
    filterSites.addItems("id", "name", [this.site]);
    this.dbFilter.addFilter(filterSites);

    let supervisionFilter = new DB_filter(DBColumnsEnum.id_supervision, null);
    supervisionFilter.value = [this.supervision.id];
    let filters = [];
    filters.push(supervisionFilter);

    //get unique issues types

    let filter = new FilterItemCollection(DBColumnsEnum.issue_type);
    let issueTypeList = lodash.uniqBy(this.issues, "type");
    let lstissueTypeCollection: FilterItem[] = [];
    if (issueTypeList.length > 0) {
      lstissueTypeCollection = issueTypeList.map(function (item) {
        let fitem = new FilterItem();
        fitem.id = item.type;
        fitem.value = fitem.id;
        fitem.viewname = IssueTypeHelper.issueGetErrorTypeDescription(fitem.id);
        return fitem;
      });
    }
    issueTypeList = SortHelper.sortMultiple(issueTypeList, ["viewname"], ['asc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);  
    filter.addItemsByFilterItemList(lstissueTypeCollection);
    this.dbFilter.addFilter(filter);

    this.filterAddList("info." + DBColumnsEnum.relevance, DBColumnsEnum.relevance);
    this.filterAddList("info.panel.panelType.brand", DBColumnsEnum.panel_brand);
    this.filterAddList("info.panel.panelType.model", DBColumnsEnum.panel_model);
    let isValidationType = !this.uiShowIssueListType();
    if (isValidationType) {
      //this.filterAddList("info.status", DBColumnsEnum.issue_status);  
    }
    //this.filterAddList("type",DBColumnsEnum.panel_model);

  }

  private filterAddList(column: string, filterColumn: any) {
    let lstp = lodash.uniqBy(this.issues, column);
    lstp = SortHelper.sortMultiple(lstp, [column], ["asc"]);
    let lst = lodash.map(lstp, column);
    lst = lst.filter(elem => elem != undefined);

    let filter = new FilterItemCollection(filterColumn);
    lst = SortHelper.sortMultiple(lst, ["viewname"], ['asc']); //_.orderBy(users, ['user', 'age'], ['asc', 'desc']);  
    filter.addItemsByList(lst);
    this.dbFilter.addFilter(filter);

  }

  /**
   * open filter modal dialog
   */
  public filterOpenModal() {
    let dialogRef: MatDialogRef<DBFilterComponent> = DBFilterComponent.openModal(this.dialog, this.dbFilter, "Filter Issues", "Select options to filter data in list and map");
    dialogRef.componentInstance.showmodulefilter = true;
    dialogRef.componentInstance.selectedEvent.subscribe(res => {
      this.filterSelectedEventHandler(res);
    });


  }


  /**
   * Handler when user clicks on filter view
   * @param selection 
   */
  private filterSelectedEventHandler(filters: IFilterItemCollection[]) {
    try {
      let filtersType: any;

      if (this.issues.length > 2000) {
        this.loading = true;
      }
      this.svFilter.addFilters(filters);
      this.mapSupervisionIssues.filterSelected = this.svFilter.filterSelected;
      this.mapSupervisionIssues.filter_status = this.svFilter.filter_status;
      //filter list based on filters

      let filteredData = this.issues.slice();

      if (this.svFilter.filter_status != SupervisionErrorStatusEnum.none) {
        filteredData = filteredData.filter(elem => elem.info.status == this.svFilter.filter_status);
      }

      if (this.svFilter.filter_status_type && this.svFilter.filter_status_type == SupervisionErrorStatusEnum.noerror) {
        //no filter, we show
      }
      else {
        //filtramos si no lo ha marcado el usuario
        filteredData = filteredData.filter(elem => elem.info.statusType != SupervisionErrorStatusEnum.noerror);
      }
      if (this.svFilter.show_issueRepeated == true) {
        //
      }
      else {
        //no show
        filteredData = filteredData.filter(elem => elem.info.issueRepeated != true);
      }


      filtersType = this.svFilter.filterSelected.find(elem => elem.id_filter == DBColumnsEnum.issue_type);
      if (filtersType) {
        let values: any[] = filtersType.value;
        filteredData = filteredData.filter(elem => values.find(item => item == elem.type));
      }

      filtersType = this.svFilter.filterSelected.find(elem => elem.id_filter == DBColumnsEnum.panel_brand);
      if (filtersType) {
        let values: any[] = filtersType.value;
        filteredData = filteredData.filter(elem => values.find(item => item == elem.info.panel.panelType.brand));
      }

      filtersType = this.svFilter.filterSelected.find(elem => elem.id_filter == DBColumnsEnum.panel_model);
      if (filtersType) {
        let values: any[] = filtersType.value;
        filteredData = filteredData.filter(elem => values.find(item => ((elem.info.panel != null && elem.info.panel.panelType != null) && item == elem.info.panel.panelType.model)));
      }

      filtersType = this.svFilter.filterSelected.find(elem => elem.id_filter == DBColumnsEnum.relevance);
      if (filtersType) {
        let values: any[] = filtersType.value;
        filteredData = filteredData.filter(elem => values.find(item => item == elem.info.relevance));
      }

      this.issuesFiltered = filteredData;

      if (this.layer_Issues) {
        this.layer_Issues.changed();
      }
      if (!filters) {
        return;
      }
    }
    catch (err) {
      this.notifyerror(err, "Error filtering issues");
    }
    this.loading = false;
  }

  exportIssuesToExcel() {
    this.solarService.supervisionExportIssuesToExcel(this.supervision.id)
      .subscribe(
        res => this.exportIssuesToExcelHandleresult()
        , err => this.exportIssuesToExcelHandleError(err)
      );
  }

  exportIssuesToExcelHandleError<T>(err: any) {
    this.loading = false;
    this.handleError(err, "Error exporting supervision to excel.<br>");
  }

  exportIssuesToExcelHandleresult() {
    this.loading = false;
    this.showNotification(NotificationType.Info, "Supervision sent to the queue to generate reports. Please wait a moment until to see reports generated in view.");
  }

  showSupervisionOptions() {

    let dialogRef: MatDialogRef<SupervOptionsComponent> = SupervOptionsComponent.openDialog(this.dialog, this);
    dialogRef.componentInstance.supervCmp = this;
    dialogRef.componentInstance.isValidator = !this.readOnlyViewType;
    /* dialogRef.componentInstance.selectedEvent.subscribe(res => {
      dialogRef.close(),
        this.filterSelectedEventHandler(res);
    }); */
  }

  saveUserConfig() {
    try {
      localStorage.setItem('issuesComponent_options', JSON.stringify(this.issuesComponent_options));
      localStorage.setItem('map_options', JSON.stringify(this.map_options));
    }
    catch (err) {
      DBG.log(DebugLevelEnum.ERROR, this.TAG, err);
    }
  }

  private loadUserConfig() {
    try {
      let item = localStorage.getItem('issuesComponent_options');
      if (item) {
        this.issuesComponent_options = JSON.parse(item);
      }
      item = localStorage.getItem('map_options');
      if (item) {
        let itemParsed = JSON.parse(item);
        let keys = Object.keys(itemParsed);

        for (let k of keys) {
          let elem = itemParsed[k];
          if (elem != undefined) {
            this.map_options[k] = elem;
          }
        }
      }
    }
    catch (err) {
      DBG.log(DebugLevelEnum.ERROR, this.TAG, err);
    }

  }
  changeissuesComponent_options(option, value) {
    this.issuesComponent_options[option] = value;
    this.saveUserConfig();
  }

  panelfind_panelChangeEvent_handler(panelLocator: any) {
    if (!panelLocator) {
      return;
    }
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, panelLocator);
    /*     let lst=this.issuesFiltered;
        let flst=lst.filter(item=>item.info.panel.name==panelName);
        DBG.log(DebugLevelEnum.VERBOSE,this.TAG,flst); */

  }

  findpanel_click_handler(panelLocator2Find: string) {
    if (panelLocator2Find == "") {
      return;
    }
    panelLocator2Find = panelLocator2Find.trim();
    let lst = this.issuesFiltered;
    let flst = lst.filter(item => item.info.panel.name == panelLocator2Find);
    DBG.log(DebugLevelEnum.VERBOSE, this.TAG, "findpanel_click_handler FILTER", flst);
    if (flst.length == 0) {
      this.showNotificationWarning("No errors were found with the entered panel. Please check that the panel name is correctly spelle. ");
    } else if (flst.length >= 1) {
      let issue = flst[0];
      this.selectIssue(issue);
      if (flst.length > 1) {
        this.showNotificationInfo("Several errors have been found with the introduced panel. Selecting the first.");
      }
    }
  }

  showAddIssueFromImage() {
    this.showEditIssue = true;
    this.errorsVisible = false;
  }
  tab_supervisiondata: boolean = true;
  tab_dashboard: boolean = false;
  tab_issues: boolean = false;
  frms_selectTab(tab) {
    switch (tab) {
      case "tab_supervisiondata":
        this.tab_dashboard = false;
        this.tab_issues = false;
        this.tab_supervisiondata = true;
        break;
      case "tab_issues":
        this.tab_dashboard = false;
        this.tab_issues = true;
        this.tab_supervisiondata = false;
        break;
      case "tab_dashboard":
        this.tab_dashboard = true;
        this.tab_issues = false;
        this.tab_supervisiondata = false;
        break;

    }
  }


  @ViewChildren(MatTooltip) matTooltipChildren!: QueryList<MatTooltip>;
  gotohack(event, url) {
    event.stopPropagation();
    event.stopImmediatePropagation(); // optional in my case
    event.preventDefault(); // optional in my case
    //this.matTooltipChildren.forEach(elem => elem.hide());
    event = event || window.event;
    var target = event.target || event.srcElement;

    setTimeout(() => {
      //this.router.navigate([url]);
      this.globService.navigateToSite(this.site);
    }, 50);
  }
  //(click)="gotohack($event,'/solar/site/'+ site?.id)"
}
